const MUTE_KEY = "asap_sound_muted";
let ctx = null;

const getCtx = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
};

export const isMuted = () => localStorage.getItem(MUTE_KEY) === "1";

export const setMuted = (muted) => {
  localStorage.setItem(MUTE_KEY, muted ? "1" : "0");
  window.dispatchEvent(new Event("asap-sound"));
};

export const unlockAudio = () => {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
};

const noiseBuffer = (c, seconds, fn) => {
  const len = Math.floor(c.sampleRate * seconds);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const data = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) data[i] = fn(Math.random() * 2 - 1, i / len, (v) => (last = v), last);
  return buf;
};

const synth = (c) => {
  const t = c.currentTime;
  const master = c.createGain();
  master.gain.value = 0.6;
  master.connect(c.destination);

  const crack = c.createBufferSource();
  crack.buffer = noiseBuffer(c, 0.4, (w, p) => w * Math.pow(1 - p, 3));
  const hp = c.createBiquadFilter();
  hp.type = "highpass";
  hp.frequency.value = 900;
  const cg = c.createGain();
  cg.gain.setValueAtTime(0.9, t);
  cg.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
  crack.connect(hp).connect(cg).connect(master);
  crack.start(t);

  const rumble = c.createBufferSource();
  rumble.buffer = noiseBuffer(c, 3, (w, p, set, last) => set((last + 0.02 * w) / 1.02) * 3.5);
  const lp = c.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.setValueAtTime(420, t);
  lp.frequency.exponentialRampToValueAtTime(90, t + 2.6);
  const rg = c.createGain();
  rg.gain.setValueAtTime(0.0001, t);
  rg.gain.exponentialRampToValueAtTime(1, t + 0.08);
  rg.gain.setValueAtTime(1, t + 0.25);
  rg.gain.exponentialRampToValueAtTime(0.6, t + 0.6);
  rg.gain.exponentialRampToValueAtTime(0.0001, t + 2.8);
  rumble.connect(lp).connect(rg).connect(master);
  rumble.start(t + 0.02);
  rumble.stop(t + 3);
};

export const playThunder = () => {
  if (isMuted()) return;
  const c = getCtx();
  if (!c) return;
  if (c.state === "running") return synth(c);
  c.resume().catch(() => {});
  setTimeout(() => { if (c.state === "running") synth(c); }, 40);
};
